import { Box } from '@radix-ui/themes';
import { PropsWithChildren, RefObject } from 'react';
import { useSelectedCollectionMetadata } from '../hooks';
import { ParallaxImage } from '@common/components/Parallax';

interface Props extends PropsWithChildren {
    scrollRef: RefObject<HTMLElement | null>;
}

export const Background = ({ children, scrollRef }: Props) => {
    const { data: metadata } = useSelectedCollectionMetadata();
    const background =
        metadata.images.background?.url || metadata.images.landscape?.url;

    return (
        <Box position='relative' width='100%' height='100%' overflow='hidden'>
            <ParallaxImage scrollRef={scrollRef} imageUrl={background} />

            <Box position='relative' style={{ zIndex: 1, height: '100%' }}>
                <Box width={'100%'} height={'100%'} p={'2'}>
                    {children}
                </Box>
            </Box>
        </Box>
    );
};
